import AOS from 'aos';
import 'aos/dist/aos.css';

AOS.init();

$('#year')
    .datetimepicker({
        format: 'YYYY'
    });

$('#to, #from, #band_group_report_to, #band_group_report_from')
    .datetimepicker({
        format: 'YYYY-MM-DD',
        calendarWeeks: true
    });

$('#meet_date')
    .datetimepicker({
        format: 'YYYY-MM-DD'
    });

document.addEventListener('DOMContentLoaded', async e => {
    if (report) {
        try {
            const f = document.getElementById('band_report_form');
            f.meet_date.value = report.meet_date;
            await fetchBandGroups(report.meet_date.split('-')[0], report.band_group_id);
            await fetchBands(report.band_group_id, report.band_id);

            for(let key in report) {
                const el = f.querySelector(`[name="${key}"]`);
                if ( el ) {
                    el.value = report[key];
                }
            }

        } catch (err) {
            console.log(err.response ?? err);
        }
    }
});


const date = document.getElementById('meet_date');
if (date) {
    date.addEventListener('focusout', e => {
        const yr = (e.target.value && e.target.value.split('-').length > 0)
            ? e.target.value.split('-')[0]
            : null;

        if (yr) {
            fetchBandGroups(yr);
        }

    });

    if (date.value.length > 0) {
        const yr = date.value.split('-')[0];
        fetchBandGroups(yr);
    }
}

function fetchBandGroups(yr, val = null) {
    const tg = document.getElementById('band_group_id');
    axios.get(`/api/bandgroups`, {
        params: {'year': yr}
    })
        .then(r => {
            const options = [
                '<option value="">교구 선택</option>'
            ];

            for (const group of r.data) {
                const {
                    id,
                    name
                } = group;
                options.push(`<option value="${id}">${name}</option>`);
            }

            tg.innerHTML = options.join('\n');
            tg.focus();

            if (val) {
                tg.value = val;
            }
        })
        .catch(err => {
            showAlert('오류', '교구 데이터를 가져오지 못했습니다.');
            console.log(err.response ? err.response : err);
        });
}


/*function fetchBandSubgroups(year, v = null) {
    const tg = document.getElementById('band_subgroup_id');
    const endpoint = `/api/bandsubgroups/fetch/${year}`;
    axios.get(endpoint)
        .then(r => {
            const options = [
                '<option value="">조 선택</option>'
            ];
            for (let row of r.data) {
                const {
                    id,
                    name
                } = row;
                options.push(`<option value="${id}">${name}</option>`);
            }
            tg.innerHTML = options.join('\n');
            tg.focus();

            if (v) {
                tg.value = v;
            }
        })
        .catch(err => {
            showAlert('오류', '소속 데이터를 가져오지 못했습니다.');
            console.log(err.response ? err.response : err);
        });
}*/

const band_group_id = document.querySelector('#band_report_form #band_group_id');
if (band_group_id) {
    band_group_id.addEventListener('change', e => {
        if (e.target.value.length === 0) return false;
        const band_group_id = e.target.value;
        fetchBands(band_group_id);
    });
}

async function fetchBands(group_id, band_id = null) {
    try {
        const r = await axios.get(`/api/bands/fetch/${group_id}`);

        const {bands} = r.data;
        let tg = document.getElementById('band_id');
        const options = [
            '<option value="">속회 선택</option>'
        ];

        bands.forEach(row => {
            const {
                id,
                name
            } = row;
            options.push(`<option value="${id}">${name}</option>`);
        });

        tg.innerHTML = options.join('\n');
        tg.focus();

        if (band_id) {
            tg.value = band_id;
        }

    } catch (err) {
        console.log(err.response ? err.response : err);
        showAlert('오류', '속회 데이터 로딩 오류');
    }
}

const band_id = document.querySelector('#band_id');
if ( band_id ) {
    band_id.addEventListener('change', async e=>{
        e.preventDefault();
        const band_members = await fetchBandMembers(e.target.value);
        console.log(band_members);
        document.querySelector('#attendances_list').value = band_members.join('\n');
        document.querySelector('#band_attandance').focus();
    })
}


async function fetchBandMembers(band_id) {
    try {
        const r = await axios.get(`/api/bands/${band_id}/members`);
        return r.data;
    } catch (err) {
        console.log(err.response ? err.response : err);
        showAlert('오류', '속회 세부 데이터 로딩 오류');
        return false;
    }
}

const band_report_form = document.getElementById('band_report_form');
if (band_report_form) {
    band_report_form.addEventListener('submit', async e => {
        e.preventDefault();
        const f = e.target;
        const submitButton = e.submitter;
        submitButton.setAttribute('disabled', '');

        f.querySelectorAll('.is-invalid, .invalid-feedback')
            .forEach(el => {
                el.classList.contains('is-invalid')
                    ? el.classList.remove('is-invalid')
                    : el.remove();
            });

        const fd = new FormData(f);

        try {

            const r = await axios.post(f.action, fd);

            f.reset();
            submitButton.removeAttribute('disabled');

            showAlert('OK', '저장 완료', 2);
            location.href = `/admin/report/show/${r.data}`;

        } catch (err) {
            console.log(err.response ?? err);
            submitButton.removeAttribute('disabled');

            if (err.response?.status === 422) {
                const {errors} = err.response.data;
                for (let key in errors) {
                    const el = f.querySelector(`[name="${key}"]`);
                    if (el) {
                        el.classList.add('is-invalid');
                        const fbEl = document.createElement('div');
                        fbEl.classList.add('invalid-feedback');
                        fbEl.textContent = errors[key];
                        el.closest('div')
                            .appendChild(fbEl);
                    }
                }
            } else if ( err.response?.status === 401 ) {
                showAlert('안내', '보고서를 저장할 권한이 없습니다.');
            } else {
                showAlert('오류', '저장 중 오류 발생, 교회 사무실로 문의바랍니다.');
            }

        }
    });
}

const band_report_download_trigger = document.getElementById('band-report-download-trigger');
if (band_report_download_trigger) {
    band_report_download_trigger.addEventListener('click', e => {
        e.preventDefault();
        const from = document.getElementById('from');
        const to = document.getElementById('to');
        if (from.value.length === 0 || to.value.length === 0) {
            showAlert('안내', '보고서를 조회할 기간을 설정하세요.', 0);
            if (from.value.length === 0) {
                from.classList.add('is-invalid');
            }
            if (to.value.length === 0) {
                to.classList.add('is-invalid');
            }
            from.focus();
            return false;
        }

        const link = document.createElement('a');
        link.target = '_blank';
        link.href = `/admin/report/download?from=${from.value}&to=${to.value}`;
        document.body.appendChild(link);
        link.click();
        link.remove();
    });
}

const deleteReportTrigger = document.getElementById('destroy-reports');
if (deleteReportTrigger) {
    deleteReportTrigger.addEventListener('click', e => {
        e.preventDefault();
        const items = document.querySelectorAll('input[name="id[]"]:checked');
        if (items.length === 0) {
            showAlert('안내', '삭제할 항목을 선택하세요.');
            return false;
        }

        if (!confirm(`${items.length}개의 항목을 삭제하시겠습니까?`)) return false;

        for (const item of items) {
            const reportId = item.value;
            const row = document.getElementById(`report-${reportId}`);

            axios.delete(`/api/band_reports/${reportId}`)
                .then(r => {
                    if (row) row.remove();
                })
                .catch(err => {
                    console.log(err.response ? err.response : err);
                    row.classList.add('table-danger');
                });
        }
    });
}
